/**
 * map.js is a VueX module to manage the map state.
 */

// initial state
const state = {
    activeSource: "",
    working: false
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
    setActiveSource(state, source) {
        state.activeSource = source
    },
    setWorking(state, working) {
        state.working = working
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}